export const SIGN_IN = 'SIGN_IN'
export const SIGN_OUT = 'SIGN_OUT'
export const MESSAGE = 'MESSAGE'
export const ADD_COMMENT = 'ADD_COMMENT'
